<div class="border-0 px-4 py-1">
  <NavigationBackButton />
  <div class="card-header card-header-primary card-nav-tabs border-0 shadow rounded-lg mt-2">
    <div class="nav-tabs-navigation">
      <div class="nav-tabs-wrapper">
        <ul class="nav nav-tabs" data-tabs="tabs">
          <li class="nav-item">
            <a class="text-white text-decoration-none text-xs nav-link fw-bold" data-toggle="tab">
              Upload Template
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="glassy-table mt-2 rounded-lg border-0 shadow">
    <div class="card-body text-xxs">
      <!-- Template Name Input -->
      <div class="mb-3">
        <label for="template_name" class="form-label fw-bold">Template name</label>
        <input type="text" class="form-control text-xxs" id="template_name" placeholder="Tax Clearance Certificate"
          v-model="template_name" />
      </div>

      <div class="mb-3">
        <label for="template_description" class="form-label fw-bold">Template Description</label>
        <input type="text" class="form-control text-xxs" id="template_description"
          placeholder="Proof that the supplier is in good standing with the tax authority." v-model="template_description" />
      </div>

      <div class="mb-3 d-none">
        <label for="template_description" class="form-label fw-bold">Template type</label>
        <select v-model="selected_template_type" class="form-select text-xxs" aria-label="Default select example">
          <option value="" disabled hidden> Select template type</option>
          <option v-for="type in template_types" :key="type.value" :value="type.value">
            {{ type.template_type }}
          </option>
        </select>
      </div>

      <!-- File Upload Input -->
      <div class="mb-3">
        <label for="template_file" class="form-label fw-bold">Upload template</label>
        <input class="form-control text-xxs" type="file" id="template_file" @change="handle_file_selection" />
      </div>

      <!-- Save Button - Fixed right after file upload -->
      <div class="mb-3 d-flex justify-content-end">
        <button type="button" class="btn btn-primary-dark btn-sm shadow-sm text-xxs" @click="upload_template"
          :disabled="loading">
          <span v-if="!loading">Save</span>
          <span v-else>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Uploading...
          </span>
        </button>
      </div>

      <!-- File Preview (appears below save button if present) -->
      <div v-if="preview_url" class="mt-3">
        <div v-if="is_previewable" class="ratio ratio-1x1 h-500">
          <iframe :src="preview_url" class="w-100 h-100 overflow-auto" frameborder="0"></iframe>
        </div>
        <div v-else>
          <p>Preview unavailable for this file type.</p>
        </div>
      </div>
    </div>
  </div>
</div>